export function CloudinaryUrl__TransformedUrl(url, options = {}) {
  // Guard against non-string inputs (e.g. a missing or object-shaped banner
  // image). Without this, `url.replace` throws "url.replace is not a function"
  // and crashes any page that renders the value (e.g. the widget timetable's
  // school banner).
  if (typeof url !== "string") return url;

  const defaultTransformations = [
    "q_auto:good",
    "f_auto",
    "fl_lossy",
    "dpr_auto",
  ];

  const transformations = [
    ...Object.entries(options).map(
      ([option, value]) => `${option[0]}_${value}`,
    ),
    ...defaultTransformations,
  ].join(",");

  if (transformations.length === 0) return url;

  return url.replace(
    /(images|image\/upload)\/(?:(?:[a-z]+_[a-z0-9]+,?)+\/)?/,
    (match, workspace) => `${workspace}/${transformations}/`,
  );
}
